import { useForm, Link } from '@inertiajs/react'
import type { FormEvent } from 'react'
import { GuestLayout } from '@/components/layout/GuestLayout'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { new_user_session_path, user_registration_path } from '@/lib/routes'

interface RegisterProps {
  errors?: {
    email?: string[]
    password?: string[]
    password_confirmation?: string[]
  }
}

// ブラウザのタイムゾーンを取得
// Intl.DateTimeFormat().resolvedOptions().timeZone で IANA タイムゾーン名を取得
function getBrowserTimezone(): string {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone
  } catch {
    return 'Asia/Tokyo' // フォールバック
  }
}

export default function Register({ errors }: RegisterProps) {
  const { data, setData, post, processing } = useForm({
    user: {
      email: '',
      password: '',
      password_confirmation: '',
      timezone: getBrowserTimezone(),
    },
  })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post(user_registration_path())
  }

  return (
    <GuestLayout>
      <form onSubmit={handleSubmit} className="space-y-6">
        <div>
          <Label htmlFor="email">メールアドレス</Label>
          <div className="mt-1">
            <Input
              id="email"
              name="email"
              type="email"
              autoComplete="email"
              required
              value={data.user.email}
              onChange={(e) =>
                setData('user', { ...data.user, email: e.target.value })
              }
            />
          </div>
          {errors?.email && (
            <p className="text-destructive mt-2 text-sm">{errors.email[0]}</p>
          )}
        </div>

        <div>
          <Label htmlFor="password">パスワード</Label>
          <div className="mt-1">
            <Input
              id="password"
              name="password"
              type="password"
              autoComplete="new-password"
              required
              value={data.user.password}
              onChange={(e) =>
                setData('user', { ...data.user, password: e.target.value })
              }
            />
          </div>
          {errors?.password && (
            <p className="text-destructive mt-2 text-sm">
              {errors.password[0]}
            </p>
          )}
        </div>

        <div>
          <Label htmlFor="password_confirmation">パスワード（確認）</Label>
          <div className="mt-1">
            <Input
              id="password_confirmation"
              name="password_confirmation"
              type="password"
              autoComplete="new-password"
              required
              value={data.user.password_confirmation}
              onChange={(e) =>
                setData('user', {
                  ...data.user,
                  password_confirmation: e.target.value,
                })
              }
            />
          </div>
          {errors?.password_confirmation && (
            <p className="text-destructive mt-2 text-sm">
              {errors.password_confirmation[0]}
            </p>
          )}
        </div>

        <div>
          <Button type="submit" className="w-full" disabled={processing}>
            アカウントを作成
          </Button>
        </div>

        <div className="text-center text-sm">
          <span className="text-muted-foreground">
            すでにアカウントをお持ちの方は{' '}
          </span>
          <Link
            href={new_user_session_path()}
            className="text-primary font-medium hover:underline"
          >
            ログイン
          </Link>
        </div>
      </form>
    </GuestLayout>
  )
}
